import { render, staticRenderFns } from "./product.vue?vue&type=template&id=e354fc90&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=e354fc90&prod&lang=scss&scoped=true&"
import style1 from "./product.vue?vue&type=style&index=1&id=e354fc90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e354fc90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Popup: require('/opt/build/repo/components/common/Popup.vue').default,ProductModifiers: require('/opt/build/repo/components/order/ProductModifiers.vue').default,ModifierSelections: require('/opt/build/repo/components/order/ModifierSelections.vue').default,IconSubtract: require('/opt/build/repo/components/icons/IconSubtract.vue').default,IconAdd: require('/opt/build/repo/components/icons/IconAdd.vue').default})
